if (!customElements.get('event-checkout-form')) {
  class EventCheckoutForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.section = this.closest('.shopify-section, dialog');
      this.quantityInput = this.querySelector('input[name="quantity"]');
      this.variantInput = this.querySelector('input[name="variant_id"]');
      this.countrySelect = this.querySelector('select[name="attributes[Nazione]"]');
      this.submitButton = this.querySelector('[data-submit-button]');
      this.submitButtonText = this.querySelector('[data-submit-button-text]');
      this.errorMessage = this.querySelector('[data-error-message]');
      this.participantsContainer = this.querySelector('[data-participants-container]');
      this.addMemberButton = this.querySelector('[data-add-participant="socio"]');
      this.addGuestButton = this.querySelector('[data-add-participant="accompagnatore"]');
      this.primaryFirstNameInput = this.querySelector('input[name="attributes[nome]"]');
      this.primaryLastNameInput = this.querySelector('input[name="attributes[cognome]"]');
      this.primaryCardInput = this.querySelector('input[name="attributes[numero_tessera]"]');
      this.primaryTaxCodeInput = this.querySelector('input[name="attributes[Codice Fiscale]"]');
      this.primaryMemberHelper = this.querySelector('[data-primary-member-help], [data-primary-card-help]');
      this.socioCheckUrl = this.dataset.socioCheckUrl || '';
      this.eventoUrl = this.dataset.eventoUrl || '';
      this.nonMemberRateUrl = this.dataset.quotaNonAssociati || '';
      this.tipoTariffa = this.dataset.tipoTariffa || '';
      this.requiresParticipantMemberValidation = ['1', '2'].includes(this.tipoTariffa);
      this.participantValidationField = this.tipoTariffa === '2' ? 'taxCode' : 'cardNumber';
      this.participantValidationLabel = this.tipoTariffa === '2' ? 'Codice Fiscale' : 'Numero tessera';
      this.primaryMemberValidationInput = this.tipoTariffa === '1'
        ? this.primaryCardInput
        : this.tipoTariffa === '2'
          ? this.primaryTaxCodeInput
          : null;
      this.cardValidationDelay = 700;
      this.cardValidationTimeouts = new Map();
      this.cardValidationControllers = new Map();
      this.cardValidationRequestId = 0;
      this.primaryMemberValidationTimeout = null;
      this.primaryMemberValidationController = null;
      this.primaryMemberValidationRequestId = 0;
      this.primaryMemberValidationStatus = 'idle';
      this.primaryMemberValidationCheckedValue = '';
      this.isSubmitting = false;
      this.isCheckoutDateValid = this.dataset.checkoutDateValid !== 'false';
      this.isVariantAvailable = !this.submitButton?.disabled;
      this.participants = [];
      this.nextParticipantId = 1;

      this.defaultButtonText = this.submitButtonText?.textContent?.trim() || 'Procedi al checkout';
      this.loadingButtonText = this.getAttribute('data-loading-label') || 'Reindirizzamento...';

      this.handleSubmit = this.handleSubmit.bind(this);
      this.handleVariantUpdate = this.handleVariantUpdate.bind(this);
      this.handleAddMember = this.handleAddMember.bind(this);
      this.handleAddGuest = this.handleAddGuest.bind(this);
      this.handleParticipantInput = this.handleParticipantInput.bind(this);
      this.handleParticipantAction = this.handleParticipantAction.bind(this);
      this.handlePrimaryMemberInput = this.handlePrimaryMemberInput.bind(this);

      this.form.addEventListener('submit', this.handleSubmit);
      this.section?.addEventListener('variant:update', this.handleVariantUpdate);
      this.addMemberButton?.addEventListener('click', this.handleAddMember);
      this.addGuestButton?.addEventListener('click', this.handleAddGuest);
      this.participantsContainer?.addEventListener('input', this.handleParticipantInput);
      this.participantsContainer?.addEventListener('click', this.handleParticipantAction);
      this.primaryFirstNameInput?.addEventListener('input', this.handlePrimaryMemberInput);
      this.primaryLastNameInput?.addEventListener('input', this.handlePrimaryMemberInput);
      this.primaryMemberValidationInput?.addEventListener('input', this.handlePrimaryMemberInput);

      this.setDefaultCountry();
      this.syncQuantityFromParticipants();
      this.renderParticipants();
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.handleSubmit);
      this.section?.removeEventListener('variant:update', this.handleVariantUpdate);
      this.addMemberButton?.removeEventListener('click', this.handleAddMember);
      this.addGuestButton?.removeEventListener('click', this.handleAddGuest);
      this.participantsContainer?.removeEventListener('input', this.handleParticipantInput);
      this.participantsContainer?.removeEventListener('click', this.handleParticipantAction);
      this.primaryFirstNameInput?.removeEventListener('input', this.handlePrimaryMemberInput);
      this.primaryLastNameInput?.removeEventListener('input', this.handlePrimaryMemberInput);
      this.primaryMemberValidationInput?.removeEventListener('input', this.handlePrimaryMemberInput);
      this.clearPrimaryMemberValidationArtifacts();
      this.clearAllParticipantValidationArtifacts();
    }

    getPrimaryMemberValues() {
      const values = {
        nome: String(this.primaryFirstNameInput?.value || '').trim(),
        cognome: String(this.primaryLastNameInput?.value || '').trim(),
      };

      // MODIFICA tipo tariffa 2: la stessa API riceve codfisc al posto di nTessera.
      if (this.tipoTariffa === '2') {
        values.codfisc = String(this.primaryTaxCodeInput?.value || '').trim();
      } else if (this.tipoTariffa === '1') {
        values.nTessera = String(this.primaryCardInput?.value || '').trim();
      }

      return values;
    }

    getPrimaryMemberValidationKey(values = this.getPrimaryMemberValues()) {
      return JSON.stringify(values);
    }

    clearPrimaryMemberValidationArtifacts() {
      if (this.primaryMemberValidationTimeout) {
        window.clearTimeout(this.primaryMemberValidationTimeout);
        this.primaryMemberValidationTimeout = null;
      }

      if (this.primaryMemberValidationController) {
        this.primaryMemberValidationController.abort();
        this.primaryMemberValidationController = null;
      }
    }

    renderPrimaryMemberValidationMessage(status) {
      if (!(this.primaryMemberHelper instanceof HTMLElement)) return;

      this.primaryMemberHelper.replaceChildren();

      if (status === 'invalid') {
        if (this.tipoTariffa === '2') {
          // MODIFICA tipo tariffa 2: messaggio specifico con collegamento alla tariffa non soci.
          this.primaryMemberHelper.append(
            'Ci dispiace, ma a seguito della verifica effettuata sui dati inseriti, non risultano precedenti iscrizioni all\'Associazione. Ti invitiamo ad usufruire della '
          );
          if (this.nonMemberRateUrl) {
            const link = document.createElement('a');
            link.href = this.nonMemberRateUrl;
            link.textContent = 'tariffa destinata ai non soci';
            this.primaryMemberHelper.append(link);
          } else {
            this.primaryMemberHelper.append('tariffa destinata ai non soci');
          }
        } else {
          this.primaryMemberHelper.append('Questa tariffa è destinata ai soli soci. Prova a selezionare una tariffa differente nella ');

          if (this.eventoUrl) {
            const link = document.createElement('a');
            link.href = this.eventoUrl;
            link.textContent = 'scheda dell\'evento';
            this.primaryMemberHelper.append(link);
          } else {
            this.primaryMemberHelper.append('scheda dell\'evento');
          }
        }
      } else if (status === 'error') {
        this.primaryMemberHelper.textContent = this.tipoTariffa === '2'
          ? 'Impossibile verificare il Codice Fiscale. Riprova.'
          : 'Impossibile verificare il numero della tessera. Riprova.';
      }

      this.primaryMemberHelper.classList.toggle('hidden', !['invalid', 'error'].includes(status));
    }

    setPrimaryMemberValidationState(status, checkedValue = '') {
      this.primaryMemberValidationStatus = status;
      this.primaryMemberValidationCheckedValue = checkedValue;

      if (this.primaryMemberValidationInput instanceof HTMLInputElement) {
        const validityMessage = status === 'invalid'
          ? this.tipoTariffa === '2'
            ? 'Codice Fiscale non associato a una precedente iscrizione.'
            : 'Numero tessera non valido per questa tariffa.'
          : '';
        this.primaryMemberValidationInput.setCustomValidity(validityMessage);
      }

      this.renderPrimaryMemberValidationMessage(status);
      this.updateSubmitButtonState();
    }

    handlePrimaryMemberInput() {
      if (!(this.primaryMemberValidationInput instanceof HTMLInputElement)) return;

      this.clearPrimaryMemberValidationArtifacts();
      this.setPrimaryMemberValidationState('idle', '');

      const values = this.getPrimaryMemberValues();
      if (!values.nome || !values.cognome || !this.primaryMemberValidationInput.value.trim()) return;

      this.setPrimaryMemberValidationState('pending', '');
      this.primaryMemberValidationTimeout = window.setTimeout(() => {
        this.primaryMemberValidationTimeout = null;
        this.validatePrimaryMember();
      }, this.cardValidationDelay);
    }

    async validatePrimaryMember() {
      if (!(this.primaryMemberValidationInput instanceof HTMLInputElement)) return true;

      const values = this.getPrimaryMemberValues();
      if (!values.nome || !values.cognome || !this.primaryMemberValidationInput.value.trim()) return false;

      const validationKey = this.getPrimaryMemberValidationKey(values);
      if (
        this.primaryMemberValidationCheckedValue === validationKey &&
        ['valid', 'invalid'].includes(this.primaryMemberValidationStatus)
      ) {
        return this.primaryMemberValidationStatus === 'valid';
      }

      this.clearPrimaryMemberValidationArtifacts();
      this.setPrimaryMemberValidationState('pending', '');

      const requestId = this.primaryMemberValidationRequestId + 1;
      this.primaryMemberValidationRequestId = requestId;
      const controller = new AbortController();
      this.primaryMemberValidationController = controller;

      try {
        if (!this.socioCheckUrl) throw new Error('URL verifica socio non disponibile.');

        const response = await fetch(this.socioCheckUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(values),
          signal: controller.signal,
        });

        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const data = await response.json();
        if (requestId !== this.primaryMemberValidationRequestId) return false;
        if (validationKey !== this.getPrimaryMemberValidationKey()) return false;

        const isValidMember = data?.success === true && Number(data?.data?.socio) === 1;
        this.setPrimaryMemberValidationState(isValidMember ? 'valid' : 'invalid', validationKey);
        return isValidMember;
      } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') return false;
        if (requestId !== this.primaryMemberValidationRequestId) return false;

        this.setPrimaryMemberValidationState('error', validationKey);
        return false;
      } finally {
        if (this.primaryMemberValidationController === controller) {
          this.primaryMemberValidationController = null;
        }
      }
    }

    handleVariantUpdate(event) {
      if (!event?.detail) return;

      if (event.detail.data?.newProduct?.id) {
        this.dataset.productId = event.detail.data.newProduct.id;
      } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
        return;
      }

      const variant = event.detail.resource;
      if (!variant) return;

      if (this.variantInput) {
        this.variantInput.value = variant.id || '';
      }

      if (this.submitButton) {
        this.isVariantAvailable = Boolean(variant.available);
      }

      if (this.quantityInput) {
        const max = variant.quantity_rule?.max;
        this.quantityInput.min = '1';
        this.quantityInput.step = '1';

        if (max !== null && max !== undefined) {
          this.quantityInput.max = String(max);
        } else {
          this.quantityInput.removeAttribute('max');
        }
      }

      this.enforceParticipantLimits();
      this.syncQuantityFromParticipants();
      this.renderParticipants();
      this.updateSubmitButtonState();
    }

    setDefaultCountry() {
      if (!this.countrySelect) return;
      const preferred = this.dataset.defaultCountry || 'Italy';
      const fallback = preferred === 'Italy' ? 'Italia' : 'Italy';

      if (this.countrySelect.value && this.countrySelect.value !== '---') return;

      if (this.countrySelect.querySelector(`option[value="${preferred}"]`)) {
        this.countrySelect.value = preferred;
        return;
      }

      if (this.countrySelect.querySelector(`option[value="${fallback}"]`)) {
        this.countrySelect.value = fallback;
      }
    }

    getQuantity() {
      const parsedQuantity = Number.parseInt(this.quantityInput?.value || '1', 10);
      return Number.isFinite(parsedQuantity) && parsedQuantity > 0 ? parsedQuantity : 1;
    }

    getGuestCount() {
      return this.participants.filter((participant) => participant.type === 'accompagnatore').length;
    }

    getAvailability() {
      const availability = Number.parseInt(this.dataset.availability || '', 10);
      return Number.isFinite(availability) && availability >= 0 ? availability : null;
    }

    getMaxQuantity() {
      const variantMax = Number.parseInt(this.quantityInput?.getAttribute('max') || '', 10);
      const limits = [
        this.getAvailability(),
        Number.isFinite(variantMax) && variantMax > 0 ? variantMax : null,
      ].filter((limit) => limit !== null);

      return limits.length > 0 ? Math.min(...limits) : null;
    }

    canIncreaseQuantity() {
      const maxQuantity = this.getMaxQuantity();
      if (maxQuantity === null) return true;

      return this.participants.length + 2 <= maxQuantity;
    }

    canAddParticipant(type) {
      if (!this.canIncreaseQuantity()) return false;
      if (type === 'accompagnatore') return this.getGuestCount() < 2;

      return true;
    }

    syncQuantityFromParticipants() {
      if (!this.quantityInput) return;

      this.quantityInput.value = String(this.participants.length + 1);
    }

    enforceParticipantLimits() {
      const maxQuantity = this.getMaxQuantity();
      const maxExtras = maxQuantity === null ? null : Math.max(maxQuantity - 1, 0);

      if (maxExtras !== null && this.participants.length > maxExtras) {
        this.participants = this.participants.slice(0, maxExtras);
      }

      let guestCount = 0;
      this.participants = this.participants.filter((participant) => {
        if (participant.type !== 'accompagnatore') return true;

        guestCount += 1;
        return guestCount <= 2;
      });
      this.cleanupRemovedParticipantValidationArtifacts();
    }

    renderParticipants() {
      if (!this.participantsContainer) return;

      if (this.participants.length === 0) {
        this.participantsContainer.innerHTML = '';
        this.participantsContainer.classList.add('hidden');
        this.updateActionButtons();
        this.updateSubmitButtonState();
        return;
      }

      this.participantsContainer.innerHTML = '';
      const fragment = document.createDocumentFragment();
      const members = this.participants.filter((participant) => participant.type === 'socio');
      const guests = this.participants.filter((participant) => participant.type === 'accompagnatore');

      if (members.length > 0) {
        fragment.appendChild(this.createParticipantGroup('Partecipanti aggiuntivi', members));
      }

      if (guests.length > 0) {
        fragment.appendChild(this.createParticipantGroup('Accompagnatori', guests));
      }

      this.participantsContainer.appendChild(fragment);
      this.participantsContainer.classList.remove('hidden');
      this.updateActionButtons();
      this.updateSubmitButtonState();
    }

    createParticipantGroup(titleText, participants) {
      const group = document.createElement('div');
      group.className = 'course-checkout-block__participant-group';

      const title = document.createElement('p');
      title.className = 'course-checkout-block__participant-group-title';
      title.textContent = titleText;
      group.appendChild(title);

      participants.forEach((participant, index) => {
        group.appendChild(this.createParticipantFieldset(participant, index + 1));
      });

      return group;
    }

    createParticipantFieldset(participant, participantIndex) {
      const fieldset = document.createElement('fieldset');
      fieldset.className = 'course-checkout-block__participant';

      const header = document.createElement('div');
      header.className = 'course-checkout-block__participant-header';

      const title = document.createElement('p');
      title.className = 'course-checkout-block__participant-title';
      title.textContent =
        participant.type === 'socio'
          ? `Partecipante aggiuntivo #${participantIndex}`
          : `Accompagnatore #${participantIndex}`;
      header.appendChild(title);

      const removeButton = document.createElement('button');
      removeButton.type = 'button';
      removeButton.className = 'course-checkout-block__participant-remove button-unstyled';
      removeButton.dataset.removeParticipant = String(participant.id);
      removeButton.textContent = 'Rimuovi';
      header.appendChild(removeButton);

      fieldset.appendChild(header);

      const fields = document.createElement('div');
      fields.className = 'course-checkout-block__participant-fields';

      fields.appendChild(this.createParticipantField(participant, 'firstName', 'Nome', 'given-name'));
      fields.appendChild(this.createParticipantField(participant, 'lastName', 'Cognome', 'family-name'));

      if (participant.type === 'socio' && this.requiresParticipantMemberValidation) {
        fields.appendChild(
          this.createParticipantField(
            participant,
            this.participantValidationField,
            this.participantValidationLabel,
            'off',
            true
          )
        );
      }

      fieldset.appendChild(fields);
      return fieldset;
    }

    createParticipantField(participant, fieldName, labelText, autocomplete, isFullWidth = false) {
      const wrapper = document.createElement('div');
      wrapper.className = 'course-checkout-block__participant-field';
      if (isFullWidth) {
        wrapper.classList.add('course-checkout-block__participant-field--full');
      }

      const safeFieldName = `participant_${participant.id}_${fieldName}`;

      const label = document.createElement('label');
      label.setAttribute('for', `${this.dataset.blockId}-${safeFieldName}`);
      label.textContent = labelText;

      const input = document.createElement('input');
      input.id = `${this.dataset.blockId}-${safeFieldName}`;
      input.name = safeFieldName;
      input.type = 'text';
      input.autocomplete = autocomplete;
      input.dataset.participantId = String(participant.id);
      input.dataset.participantField = fieldName;
      input.value = participant[fieldName] || '';
      input.required = true;

      const isMemberValidationField = fieldName === this.participantValidationField;
      if (isMemberValidationField) {
        input.autocapitalize = 'characters';
      }

      wrapper.appendChild(label);
      const inputWrapper = document.createElement('div');
      inputWrapper.className = 'course-checkout-block__participant-input-wrapper';
      inputWrapper.appendChild(input);

      let loader = null;
      if (isMemberValidationField) {
        loader = document.createElement('span');
        loader.className = 'course-checkout-block__participant-loader hidden';
        loader.dataset.participantId = String(participant.id);
        loader.dataset.participantLoader = this.participantValidationField;
        loader.setAttribute('aria-hidden', 'true');
        inputWrapper.appendChild(loader);
      }

      wrapper.appendChild(inputWrapper);

      let helper = null;
      if (isMemberValidationField) {
        helper = document.createElement('p');
        helper.className = 'course-checkout-block__participant-help hidden';
        helper.dataset.participantId = String(participant.id);
        helper.dataset.participantHelp = this.participantValidationField;
        helper.setAttribute('aria-live', 'polite');
        wrapper.appendChild(helper);
      }

      if (isMemberValidationField) {
        this.applyParticipantCardValidationState(participant, input, loader, helper);
      }

      return wrapper;
    }

    handleAddMember() {
      this.addParticipant('socio');
    }

    handleAddGuest() {
      this.addParticipant('accompagnatore');
    }

    addParticipant(type) {
      if (!this.canAddParticipant(type)) return;

      this.participants.push({
        id: this.nextParticipantId,
        type,
        firstName: '',
        lastName: '',
        cardNumber: '',
        taxCode: '',
        cardValidationStatus: 'idle',
        cardValidationCheckedValue: '',
        cardValidationMessage: '',
        cardValidationRequestId: 0,
      });
      this.nextParticipantId += 1;

      this.syncQuantityFromParticipants();
      this.renderParticipants();
    }

    handleParticipantInput(event) {
      const input = event.target;
      if (!(input instanceof HTMLInputElement)) return;

      const participantId = Number.parseInt(input.dataset.participantId || '', 10);
      const participantField = input.dataset.participantField;
      if (!Number.isFinite(participantId) || !participantField) return;

      const participant = this.participants.find((entry) => entry.id === participantId);
      if (!participant) return;

      participant[participantField] = input.value;

      if (
        this.requiresParticipantMemberValidation &&
        participant.type === 'socio' &&
        ['firstName', 'lastName', this.participantValidationField].includes(participantField)
      ) {
        this.scheduleParticipantCardValidation(participant);
      }
    }

    handleParticipantAction(event) {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const removeButton = target.closest('[data-remove-participant]');
      if (!(removeButton instanceof HTMLElement)) return;

      const participantId = Number.parseInt(removeButton.dataset.removeParticipant || '', 10);
      if (!Number.isFinite(participantId)) return;

      this.clearParticipantValidationArtifacts(participantId);
      this.participants = this.participants.filter((participant) => participant.id !== participantId);
      this.syncQuantityFromParticipants();
      this.renderParticipants();
      this.updateSubmitButtonState();
    }

    getParticipantCardInput(participantId) {
      return this.querySelector(
        `input[data-participant-id="${participantId}"][data-participant-field="${this.participantValidationField}"]`
      );
    }

    getParticipantCardLoader(participantId) {
      return this.querySelector(
        `[data-participant-id="${participantId}"][data-participant-loader="${this.participantValidationField}"]`
      );
    }

    getParticipantCardHelper(participantId) {
      return this.querySelector(
        `[data-participant-id="${participantId}"][data-participant-help="${this.participantValidationField}"]`
      );
    }

    getParticipantMemberValues(participant) {
      const values = {
        nome: String(participant.firstName || '').trim(),
        cognome: String(participant.lastName || '').trim(),
      };

      if (this.tipoTariffa === '2') {
        values.codfisc = String(participant.taxCode || '').trim();
      } else {
        values.nTessera = String(participant.cardNumber || '').trim();
      }

      return values;
    }

    getParticipantMemberValidationKey(participant) {
      return JSON.stringify(this.getParticipantMemberValues(participant));
    }

    getParticipantCardValidationMessage(participant) {
      if (participant.cardValidationStatus === 'invalid') {
        return this.tipoTariffa === '2'
          ? 'Codice Fiscale non associato a una precedente iscrizione.'
          : 'Numero tessera non valido.';
      }
      if (participant.cardValidationStatus === 'error') {
        return this.tipoTariffa === '2'
          ? 'Impossibile verificare il Codice Fiscale.'
          : 'Impossibile verificare il numero della tessera.';
      }

      return '';
    }

    getParticipantCardHelperMessage(participant) {
      const validationValue = String(participant[this.participantValidationField] || '').trim();
      if (validationValue === '') return '';
      if (participant.cardValidationStatus === 'invalid') {
        return this.tipoTariffa === '2'
          ? 'Ci dispiace, ma a seguito della verifica effettuata sui dati inseriti, non risultano precedenti iscrizioni all\'Associazione. Ti invitiamo ad usufruire della '
          : 'Il numero della tessera risulta non valido.';
      }
      if (participant.cardValidationStatus === 'error') {
        return this.tipoTariffa === '2'
          ? 'Impossibile verificare il Codice Fiscale.'
          : 'Impossibile verificare il numero della tessera.';
      }

      return '';
    }

    applyParticipantCardValidationState(
      participant,
      input = this.getParticipantCardInput(participant.id),
      loader = this.getParticipantCardLoader(participant.id),
      helper = this.getParticipantCardHelper(participant.id)
    ) {
      if (!(input instanceof HTMLInputElement)) return;

      const message = this.getParticipantCardValidationMessage(participant);
      participant.cardValidationMessage = message;
      input.setCustomValidity(message);

      const fieldWrapper = input.closest('.course-checkout-block__participant-field');
      const isPending = participant.cardValidationStatus === 'pending';
      const helperMessage = this.getParticipantCardHelperMessage(participant);

      fieldWrapper?.classList.toggle('course-checkout-block__participant-field--loading', isPending);
      loader?.classList.toggle('hidden', !isPending);

      if (helper instanceof HTMLElement) {
        helper.replaceChildren();
        helper.append(helperMessage);

        if (this.tipoTariffa === '2' && participant.cardValidationStatus === 'invalid') {
          if (this.nonMemberRateUrl) {
            const link = document.createElement('a');
            link.href = this.nonMemberRateUrl;
            link.textContent = 'tariffa destinata ai non soci';
            helper.append(link);
          } else {
            helper.append('tariffa destinata ai non soci');
          }
        }

        helper.classList.toggle('hidden', helperMessage === '');
      }
    }

    setParticipantCardValidationState(participant, status, checkedValue = '') {
      participant.cardValidationStatus = status;
      participant.cardValidationCheckedValue = checkedValue;
      this.applyParticipantCardValidationState(participant);
      this.updateSubmitButtonState();
    }

    clearParticipantValidationTimer(participantId) {
      const timeoutId = this.cardValidationTimeouts.get(participantId);
      if (timeoutId) {
        window.clearTimeout(timeoutId);
        this.cardValidationTimeouts.delete(participantId);
      }
    }

    abortParticipantValidationRequest(participantId) {
      const controller = this.cardValidationControllers.get(participantId);
      if (controller) {
        controller.abort();
        this.cardValidationControllers.delete(participantId);
      }
    }

    clearParticipantValidationArtifacts(participantId) {
      this.clearParticipantValidationTimer(participantId);
      this.abortParticipantValidationRequest(participantId);
    }

    clearAllParticipantValidationArtifacts() {
      Array.from(this.cardValidationTimeouts.keys()).forEach((participantId) => {
        this.clearParticipantValidationTimer(participantId);
      });
      Array.from(this.cardValidationControllers.keys()).forEach((participantId) => {
        this.abortParticipantValidationRequest(participantId);
      });
    }

    cleanupRemovedParticipantValidationArtifacts() {
      const activeParticipantIds = new Set(this.participants.map((participant) => participant.id));

      Array.from(this.cardValidationTimeouts.keys()).forEach((participantId) => {
        if (!activeParticipantIds.has(participantId)) {
          this.clearParticipantValidationTimer(participantId);
        }
      });

      Array.from(this.cardValidationControllers.keys()).forEach((participantId) => {
        if (!activeParticipantIds.has(participantId)) {
          this.abortParticipantValidationRequest(participantId);
        }
      });
    }

    hasPendingCardValidation() {
      if (!this.requiresParticipantMemberValidation) return false;

      return this.participants.some((participant) => {
        if (participant.type !== 'socio') return false;
        if (String(participant[this.participantValidationField] || '').trim() === '') return false;

        return participant.cardValidationStatus === 'pending';
      });
    }

    scheduleParticipantCardValidation(participant) {
      if (participant.type !== 'socio' || !this.requiresParticipantMemberValidation) return;

      const values = this.getParticipantMemberValues(participant);
      const validationValue = String(participant[this.participantValidationField] || '').trim();
      this.clearParticipantValidationTimer(participant.id);
      this.abortParticipantValidationRequest(participant.id);

      if (!values.nome || !values.cognome || !validationValue) {
        this.setParticipantCardValidationState(participant, 'idle', '');
        return;
      }

      this.setParticipantCardValidationState(participant, 'pending', '');

      const timeoutId = window.setTimeout(() => {
        this.cardValidationTimeouts.delete(participant.id);
        this.validateParticipantCard(participant.id);
      }, this.cardValidationDelay);

      this.cardValidationTimeouts.set(participant.id, timeoutId);
    }

    async validateParticipantCard(participantId) {
      const participant = this.participants.find((entry) => entry.id === participantId);
      if (!participant || participant.type !== 'socio' || !this.requiresParticipantMemberValidation) return;

      const values = this.getParticipantMemberValues(participant);
      const validationValue = String(participant[this.participantValidationField] || '').trim();
      if (!values.nome || !values.cognome || !validationValue) {
        this.setParticipantCardValidationState(participant, 'idle', '');
        return;
      }
      const validationKey = this.getParticipantMemberValidationKey(participant);

      const requestId = this.cardValidationRequestId + 1;
      this.cardValidationRequestId = requestId;
      participant.cardValidationRequestId = requestId;

      const controller = new AbortController();
      this.cardValidationControllers.set(participantId, controller);

      try {
        const response = await fetch(this.socioCheckUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(values),
          signal: controller.signal,
        });

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const data = await response.json();
        const currentParticipant = this.participants.find((entry) => entry.id === participantId);
        if (!currentParticipant) return;

        const currentValidationKey = this.getParticipantMemberValidationKey(currentParticipant);
        if (currentParticipant.cardValidationRequestId !== requestId || currentValidationKey !== validationKey) return;

        if (data?.success === true && Number(data?.data?.socio) === 1) {
          this.setParticipantCardValidationState(currentParticipant, 'valid', validationKey);
        } else {
          this.setParticipantCardValidationState(currentParticipant, 'invalid', validationKey);
        }
      } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') return;

        const currentParticipant = this.participants.find((entry) => entry.id === participantId);
        if (!currentParticipant) return;

        const currentValidationKey = this.getParticipantMemberValidationKey(currentParticipant);
        if (currentParticipant.cardValidationRequestId !== requestId || currentValidationKey !== validationKey) return;

        this.setParticipantCardValidationState(currentParticipant, 'error', validationKey);
      } finally {
        const activeController = this.cardValidationControllers.get(participantId);
        if (activeController === controller) {
          this.cardValidationControllers.delete(participantId);
        }
      }
    }

    syncParticipantCardValidationStates() {
      this.participants.forEach((participant) => {
        if (participant.type !== 'socio') return;

        if (!this.requiresParticipantMemberValidation) {
          this.setParticipantCardValidationState(participant, 'idle', '');
          return;
        }

        const values = this.getParticipantMemberValues(participant);
        const validationValue = String(participant[this.participantValidationField] || '').trim();
        if (!values.nome || !values.cognome || !validationValue) {
          this.setParticipantCardValidationState(participant, 'idle', '');
          return;
        }
        const validationKey = this.getParticipantMemberValidationKey(participant);

        if (participant.cardValidationCheckedValue === validationKey && participant.cardValidationStatus === 'valid') {
          this.applyParticipantCardValidationState(participant);
          return;
        }

        if (
          participant.cardValidationCheckedValue === validationKey &&
          ['pending', 'invalid'].includes(participant.cardValidationStatus)
        ) {
          this.applyParticipantCardValidationState(participant);
          return;
        }

        this.setParticipantCardValidationState(participant, 'pending', '');

        if (!this.cardValidationTimeouts.has(participant.id) && !this.cardValidationControllers.has(participant.id)) {
          this.validateParticipantCard(participant.id);
        }
      });
    }

    updateActionButtons() {
      if (this.addMemberButton) {
        this.addMemberButton.disabled = !this.canAddParticipant('socio');
      }

      if (this.addGuestButton) {
        this.addGuestButton.disabled = !this.canAddParticipant('accompagnatore');
      }
    }

    updateSubmitButtonState() {
      if (!this.submitButton) return;

      const hasVariantId = Boolean(this.variantInput?.value);
      const shouldDisable =
        this.isSubmitting ||
        !this.isCheckoutDateValid ||
        !hasVariantId ||
        !this.isVariantAvailable ||
        (this.getMaxQuantity() !== null && this.getQuantity() > this.getMaxQuantity()) ||
        this.primaryMemberValidationStatus === 'pending' ||
        this.hasPendingCardValidation();

      this.submitButton.disabled = shouldDisable;
    }

    showError(message) {
      if (!this.errorMessage) return;
      this.errorMessage.textContent = message;
      this.errorMessage.classList.remove('hidden');
    }

    clearError() {
      if (!this.errorMessage) return;
      this.errorMessage.textContent = '';
      this.errorMessage.classList.add('hidden');
    }

    setSubmittingState(isSubmitting) {
      if (!this.submitButton) return;

      this.isSubmitting = isSubmitting;
      this.updateSubmitButtonState();
      this.submitButton.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');

      if (this.submitButtonText) {
        this.submitButtonText.textContent = isSubmitting ? this.loadingButtonText : this.defaultButtonText;
      }
    }

    buildExtraParticipantAttributeEntries() {
      const attributes = [];
      const orderedParticipants = [
        ...this.participants.filter((participant) => participant.type === 'socio'),
        ...this.participants.filter((participant) => participant.type === 'accompagnatore'),
      ];
      let memberIndex = 0;
      let guestIndex = 0;

      for (const participant of orderedParticipants) {
        const firstName = String(participant.firstName || '').trim();
        const lastName = String(participant.lastName || '').trim();
        const cardNumber = String(participant.cardNumber || '').trim();
        const taxCode = String(participant.taxCode || '').trim();

        if (participant.type === 'socio') {
          memberIndex += 1;
          if (firstName) {
            attributes.push([`partecipante_aggiuntivo_${memberIndex}_nome`, firstName]);
          }
          if (lastName) {
            attributes.push([`partecipante_aggiuntivo_${memberIndex}_cognome`, lastName]);
          }
          if (cardNumber) {
            attributes.push([`partecipante_aggiuntivo_${memberIndex}_numero_tessera`, cardNumber]);
          }
          if (taxCode) {
            attributes.push([`partecipante_aggiuntivo_${memberIndex}_codice_fiscale`, taxCode]);
          }
        } else {
          guestIndex += 1;
          if (firstName) {
            attributes.push([`accompagnatore_${guestIndex}_nome`, firstName]);
          }
          if (lastName) {
            attributes.push([`accompagnatore_${guestIndex}_cognome`, lastName]);
          }
        }
      }

      return attributes;
    }

    extractAttributeName(fieldName) {
      if (typeof fieldName !== 'string') return null;
      if (!fieldName.startsWith('attributes[') || !fieldName.endsWith(']')) return null;

      return fieldName.slice(11, -1).trim();
    }

    buildCartAttributeEntries() {
      const formData = new FormData(this.form);
      const attributes = [];

      for (const [fieldName, value] of formData.entries()) {
        const attributeName = this.extractAttributeName(fieldName);
        if (!attributeName) continue;

        const normalizedValue = String(value || '').trim();
        if (normalizedValue !== '') {
          attributes.push([attributeName, normalizedValue]);
        }
      }

      attributes.push(...this.buildExtraParticipantAttributeEntries());

      return attributes;
    }

    buildCartAttributesPayload() {
      const legacyAttributeNames = [
        'Nome',
        'Cognome',
        'Numero tessera',
        'Codice Fiscale',
        'Email',
        'Indirizzo',
        'Città',
        'Provincia',
        'CAP',
        'Nazione',
        'Data di Nascita',
        'Città di Nascita',
        'Provincia di Nascita',
        'Telefono',
        'Partecipanti aggiuntivi',
        'Accompagnatori',
      ];
      const payload = legacyAttributeNames.reduce((attributes, attributeName) => {
        attributes[attributeName] = '';
        return attributes;
      }, {});

      return this.buildCartAttributeEntries().reduce((attributes, [attributeName, attributeValue]) => {
        attributes[attributeName] = attributeValue;
        return attributes;
      }, payload);
    }

    extractPropertyName(fieldName) {
      if (typeof fieldName !== 'string') return null;
      if (!fieldName.startsWith('properties[') || !fieldName.endsWith(']')) return null;

      return fieldName.slice(11, -1).trim();
    }

    buildLineItemPropertiesPayload() {
      const formData = new FormData(this.form);
      const properties = {};

      for (const [fieldName, value] of formData.entries()) {
        const propertyName = this.extractPropertyName(fieldName);
        if (!propertyName) continue;

        const normalizedValue = String(value || '').trim();
        if (normalizedValue !== '') {
          properties[propertyName] = normalizedValue;
        }
      }

      return properties;
    }

    buildCheckoutItems(variantId, quantity) {
      const properties = this.buildLineItemPropertiesPayload();
      const item = {
        id: variantId,
        quantity,
      };

      if (Object.keys(properties).length > 0) {
        item.properties = properties;
      }

      return [
        item,
      ];
    }

    getRootPath() {
      const rootPath = window.Shopify?.routes?.root || '/';
      return rootPath.endsWith('/') ? rootPath : `${rootPath}/`;
    }

    getCartAddUrl() {
      return window.Theme?.routes?.cart_add_url || `${this.getRootPath()}cart/add.js`;
    }

    getCartUpdateUrl() {
      return window.Theme?.routes?.cart_update_url || `${this.getRootPath()}cart/update`;
    }

    getCartClearUrl() {
      return `${this.getRootPath()}cart/clear.js`;
    }

    getCheckoutUrl() {
      const checkoutUrl = `${this.getRootPath()}checkout`;
      const formData = new FormData(this.form);
      const formFields = this.dataset.checkoutPrefillSource === 'customer'
        ? { email: 'customer_email', firstName: 'customer_first_name', lastName: 'customer_last_name' }
        : { email: 'attributes[Email]', firstName: 'attributes[nome]', lastName: 'attributes[cognome]' };
      const mappings = [
        ['checkout[email]', formFields.email],
        ['checkout[shipping_address][first_name]', formFields.firstName],
        ['checkout[shipping_address][last_name]', formFields.lastName],
      ];
      const searchParams = new URLSearchParams();

      mappings.forEach(([checkoutField, formField]) => {
        const value = String(formData.get(formField) || '').trim();
        if (value) searchParams.set(checkoutField, value);
      });

      const queryString = searchParams.toString();
      return queryString ? `${checkoutUrl}?${queryString}` : checkoutUrl;
    }

    async postCartJson(url, payload = {}) {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(payload),
      });

      let data = null;

      try {
        data = await response.json();
      } catch (error) {
        data = null;
      }

      if (!response.ok || data?.status) {
        const errorMessage = data?.description || data?.message || `HTTP ${response.status}`;
        throw new Error(errorMessage);
      }

      return data;
    }

    async submitCheckoutCart(variantId, quantity) {
      const items = this.buildCheckoutItems(variantId, quantity);

      await this.postCartJson(this.getCartClearUrl());

      await this.postCartJson(this.getCartAddUrl(), { items });

      const attributes = this.buildCartAttributesPayload();
      if (Object.keys(attributes).length > 0) {
        await this.postCartJson(this.getCartUpdateUrl(), { attributes });
      }

      return this.getCheckoutUrl();
    }

    async handleSubmit(event) {
      event.preventDefault();

      if (!this.isCheckoutDateValid) return;
      this.syncParticipantCardValidationStates();

      if (this.hasPendingCardValidation()) {
        this.updateSubmitButtonState();
        return;
      }

      if (!this.form.reportValidity()) return;

      const isPrimaryMemberValid = await this.validatePrimaryMember();
      if (!isPrimaryMemberValid) {
        this.primaryMemberValidationInput?.reportValidity();
        return;
      }

      const variantId = Number.parseInt(this.variantInput?.value || '', 10);
      const quantity = this.getQuantity();

      if (!Number.isFinite(variantId) || variantId <= 0) {
        this.showError('Variante non valida.');
        return;
      }

      this.clearError();
      this.setSubmittingState(true);

      try {
        const checkoutUrl = await this.submitCheckoutCart(variantId, quantity);
        window.location.assign(checkoutUrl);
      } catch (error) {
        this.showError(error instanceof Error ? error.message : 'Si e verificato un errore inatteso.');
        this.setSubmittingState(false);
      }
    }
  }

  customElements.define('event-checkout-form', EventCheckoutForm);
}
